import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'
import type { User } from './auth/model'

export class GetCurators extends Performer<void, User[]> {
  protected method = HttpMethod.GET
  protected url = '/curators'
}

export default new GetCurators().perform
